module.exports = __webpack_public_path__ + "img/anniston-water-logo.19679d7e.jpg";